import { Router } from '@angular/router';
import { AppHttpClient } from '../../core/http/app-http-client.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../core/http/app-http-client.service";
var AppearanceEditorResolver = /** @class */ (function () {
    function AppearanceEditorResolver(router, http) {
        this.router = router;
        this.http = http;
    }
    AppearanceEditorResolver.prototype.resolve = function (route, state) {
        var _this = this;
        return this.http.get('admin/appearance/values').pipe(catchError(function () {
            _this.router.navigate(['/admin']);
            return EMPTY;
        }), mergeMap(function (response) {
            if (response) {
                return of(response);
            }
            else {
                _this.router.navigate(['/admin']);
                return EMPTY;
            }
        }));
    };
    AppearanceEditorResolver.ngInjectableDef = i0.defineInjectable({ factory: function AppearanceEditorResolver_Factory() { return new AppearanceEditorResolver(i0.inject(i1.Router), i0.inject(i2.AppHttpClient)); }, token: AppearanceEditorResolver, providedIn: "root" });
    return AppearanceEditorResolver;
}());
export { AppearanceEditorResolver };
